import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";

const options = {
  confirmButtonColor: "#192028",
  cancelButtonColor: "#B71C1C",
  confirmButtonText: "Okay",
  // backdrop: "rgba(25, 32, 40, 0.25",
  // customClass: {},
  // background: "#FCFCFC",
};

Vue.use(VueSweetalert2, options);


Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
